import { Injectable } from '@angular/core';
import {WorkUpdate} from "./add-edit-work-update/add-edit-work-update.component";
import {AngularFirestore} from "@angular/fire/compat/firestore";

@Injectable({
  providedIn: 'root'
})
export class WorkUpdateServiceService {

  private collectionName = 'ALEducationWorkUpdates';

  constructor(private afs: AngularFirestore) {}

  addWorkUpdate(data: WorkUpdate) {
    const id = this.afs.createId();
    return this.afs.collection(this.collectionName).doc(id).set({
      ...data,
      id,
      createdAt: new Date()
    });
  }

  updateWorkUpdate(id: string, data: any) {
    return this.afs.collection(this.collectionName).doc(id).update(data);
  }

  deleteWorkUpdate(id: string) {
    return this.afs.collection(this.collectionName).doc(id).delete();
  }

  getAllWorkUpdates() {
    return this.afs.collection<WorkUpdate>(this.collectionName, ref =>
      ref.orderBy('date', 'desc')
    ).valueChanges();
  }

  getWorkUpdateById(id: string) {
    return this.afs.collection(this.collectionName).doc(id).valueChanges();
  }
}
